"use client";

import dynamic from "next/dynamic";

const YouTubeLiveAlert = dynamic(
  () => import("@jesus-central-church/ui/src/components/youtube-live-alert").then((mod) => ({ default: mod.YouTubeLiveAlert })),
  { ssr: false }
);

interface LiveAlertProps {
  includeYouTubeLiveAlert?: boolean;
}

export function LiveAlert({
  includeYouTubeLiveAlert = false,
}: LiveAlertProps) {
  return (
    <>
      {includeYouTubeLiveAlert && <YouTubeLiveAlert />}
    </>
  );
}
